/* eslint-disable arrow-parens */
// Progress 进度条
import NProgress from 'nprogress';
// Progress 进度条样式
import 'nprogress/nprogress.css';

import router from './router';
import store from './store';
import oss from '@/utils/oss';

import { authUtils } from './utils';

// 不重定向白名单
const whiteList = [
    '/login',
    '/elementDemo',
    // '/antdvDemo',
    '/itegralManage',
    '/404',
];
function hasNotPermission(nodeList, name) {
    return nodeList.some(node => {
        if ((node.name === name || `${node.name}Index` === name) && typeof node.auth === 'boolean' && !node.auth) return true;
        return hasNotPermission(node.children || [], name);
    });
}
router.beforeEach(async (to, from, next) => {
    if (authUtils.getToken()) {
        if (to.path === '/login') {
            await store.dispatch('user/LogOut', 'local');
        } else if (!store.state.user.isGetUserInfo) {
            NProgress.start();

            oss.downloadFile('test').then(() => {
            }).catch(() => {
            });
            // 拉取用户信息
            try {
                await store.dispatch('user/GetUserInfo');

                await store.dispatch('permission/GenerateRoutes');
                router.addRoutes(store.state.permission.addRouters);
                next({ ...to, replace: true });
            } catch (err) {
                NProgress.done();
            }
        } else {
            if (to.matched.length === 0) next('/404');
            // if (hasNotPermission(store.state.user.userMenuTree, to.name)) {
            //     Message.warning({
            //         message: '暂未开通此模块权限，如有需要请向店铺管理员申请开通权限',
            //         duration: 3000,
            //     });
            // }
            next();
        }
    } else if (whiteList.indexOf(to.path) !== -1) {
        NProgress.start();

        next();
    } else {
        NProgress.start();

        next('/login');
        NProgress.done();
    }
});

router.afterEach(() => {
    // 结束Progress
    NProgress.done();
});
